import { render, staticRenderFns } from "./WidgetCenter.vue?vue&type=template&id=333d2fa3&scoped=true"
import script from "./WidgetCenter.vue?vue&type=script&lang=js"
export * from "./WidgetCenter.vue?vue&type=script&lang=js"
import style0 from "./WidgetCenter.vue?vue&type=style&index=0&id=333d2fa3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333d2fa3",
  null
  
)

export default component.exports